import type { RcFile } from 'antd/es/upload';
import type { UploadProps } from 'antd/lib';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Image, message, Upload } from 'antd';
import { useState } from 'react';
import type { UploadRequestOption } from '@/types/antd';
import { fileToBase64 } from '@/std/base64';

export function UploadImage({
    imageUrl,
    onChange,
}: {
    imageUrl?: string;
    onChange: (fileName: string, base64: string) => void;
}) {
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(imageUrl || '');

    const beforeUpload = (file: RcFile): boolean => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('Somente imagens JPG e PNG são aceitas.');
        }

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('O arquivo deve ser menor que 2MB!');
        }

        return isJpgOrPng && isLt2M;
    };

    const handleChange: UploadProps['onChange'] = (info) => {
        if (info.file.status === 'uploading') {
            setLoading(true);
        }

        if (info.file.status === 'done') {
            setLoading(false);
        }
    };

    const customRequest = async (options: UploadRequestOption): Promise<void> => {
        let file: Blob;
        let fileName = options.filename || '';

        if (typeof options.file === 'string') {
            file = new Blob([options.file]);
        } else {
            file = options.file;

            if ('name' in options.file) {
                fileName = options.file.name;
            }
        }

        const base64 = await fileToBase64(file);
        setImage(`data:image/png;base64,${base64}`);
        onChange(fileName, base64);
        options.onSuccess?.({});
    };

    return (
        <Upload
            beforeUpload={beforeUpload}
            customRequest={customRequest}
            name='avatar'
            onChange={handleChange}
            showUploadList={false}
        >
            {image ? (
                <Image
                    alt=''
                    preview={{ zIndex: 1051 }}
                    src={image}
                    style={{ aspectRatio: 1, height: 32 }}
                />
            ) : (
                <button style={{ background: 'none', border: 0 }} type='button'>
                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                </button>
            )}
        </Upload>
    );
}
